import { render, staticRenderFns } from "./bulkimport.vue?vue&type=template&id=23bde028&scoped=true"
import script from "./bulkimport.vue?vue&type=script&lang=js"
export * from "./bulkimport.vue?vue&type=script&lang=js"
import style0 from "./bulkimport.vue?vue&type=style&index=0&id=23bde028&prod&lang=scss&scoped=true"
import style1 from "./bulkimport.vue?vue&type=style&index=1&id=23bde028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bde028",
  null
  
)

export default component.exports